import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-status-color-indicator',
    templateUrl: './status-color-indicator.component.html',
    styleUrls: ['./status-color-indicator.component.css'],
    standalone: false,
})
export class StatusColorIndicatorComponent implements OnChanges {
    @Input() statusString: string;
    @Input() color: string;
    @Input() readonly: boolean = false;

    rgb: string = '';
    alpha: number = 100;

    @Output() onColorChange = new EventEmitter();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.color && this.color) {
            this.parseRGBA(this.color);
        }
    }

    parseRGBA(rgbaString: string) {
        const match = rgbaString.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d\.]+)?\)/);

        if (!match) {
            return;
        }

        const r = parseInt(match[1], 10);
        const g = parseInt(match[2], 10);
        const b = parseInt(match[3], 10);
        const a = match[4] !== undefined ? parseFloat(match[4]) : 1;

        this.rgb = `${r}, ${g}, ${b}`;
        this.alpha = Math.round(a * 100);
    }
}
